import { applyMiddleware, createStore } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { createLogger } from 'redux-logger';
import UrlHelper from 'utils/helper/url-helper';
import reducers from './reducers/reducers';
import apiMiddlewareInterceptor from '../services/api-middleware-interceptor';

const debugLogger = createLogger({ collapsed: true, });

const store =
  UrlHelper.getEnvironment() === 'production'
    ? createStore(reducers, applyMiddleware(apiMiddlewareInterceptor, apiMiddleware))
    : createStore(reducers, applyMiddleware(apiMiddlewareInterceptor, apiMiddleware, debugLogger));

export default store;
